import classNames from "classnames";
import React, { forwardRef, useImperativeHandle, useState } from "react";

type ModalProps = {
  children: React.ReactNode;
  closeOnWrapper?: boolean;
  onClosed?: () => void;
  className?: string;
};

export type ModalHandle = {
  open: () => void;
  close: () => void;
  getOpened: () => boolean;
};

function Modal({ children, onClosed, closeOnWrapper = true, className }: ModalProps, ref: any) {
  const [opened, setOpened] = useState(false);

  useImperativeHandle(ref, () => ({
    open() {
      setOpened(true);
    },
    close() {
      setOpened(false);
      onClosed && onClosed();
    },
    getOpened() {
      return opened;
    },
  }));

  return opened ? (
    <div
      ref={ref}
      className={classNames("fixed left-0 top-0 z-50 flex h-screen w-full items-center justify-center p-5")}>
      <div
        className={classNames("absolute left-0 top-0 z-10 flex h-screen w-full bg-black opacity-70", "")}
        onClick={() => {
          if (closeOnWrapper) {
            setOpened(false);
            onClosed && onClosed();
          }
        }}
      />
      <div
        className={classNames(
          "border-subtle bg-muted relative z-20 w-full max-w-4xl rounded-lg p-4 md:p-8",
          className
        )}>
        {children}
      </div>
    </div>
  ) : null;
}

export default forwardRef<ModalHandle, ModalProps>(Modal);
